import React from 'react';
import './Header.css';
import useAutoTranslate from '../../hooks/useAutoTranslate';
import fr from './langue/fr.json';
import en from './langue/en.json';

const certifications = [
  {
    href: `${process.env.PUBLIC_URL}/assets/csna.pdf`,
    img: `${process.env.PUBLIC_URL}/assets/img/techno/csna.png`,
    alt: 'CSNA',
  },
  {
    href: `${process.env.PUBLIC_URL}/assets/Label%20Handimanagement.pdf`,
    img: `${process.env.PUBLIC_URL}/assets/img/techno/lh.png`,
    alt: 'Label Handimanagement',
  },
];

function Header({ onOpenCarte }) {
  const t = useAutoTranslate({ fr, en });

  return (
    <header className="header" id="page-top">
      <div className="header__bg"></div>
      <div className="header__content">
        <img
          className="header__photo"
          src="assets/img/photo.png"
          alt={`${t('prenom')} ${t('nom')}`}
        />
        <div className="header__text">
          <p className="header__sub">//{t('bienvenue')}</p>
          <h1 className="header__title">{t('prenom')}<br />{t('nom')}</h1>
          <div className="header__line"></div>
          <p className="header__role">{t('role')}</p>
          <div className="header__ctas">
            <a href="#moi" className="btn-primary">{t('cta_decouvrir')}</a>
            <a href="#portfolio" className="btn-secondary">{t('cta_projets')}</a>
            <a href="#comp" className="btn-secondary btn-cv">{t('cta_cv')}</a>
            <a href="#contact" className="btn-secondary">{t('cta_contact')}</a>
          </div>
          <div className="header__certs">
            {certifications.map((cert) => (
              <a
                key={cert.alt}
                href={cert.href}
                target="_blank"
                rel="noreferrer"
                className="header__cert-link"
                title={cert.alt}
              >
                <img src={cert.img} alt={cert.alt} />
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Bouton carte — visible uniquement sur mobile dans le header */}
      <button
        className="header__carte-btn"
        onClick={onOpenCarte}
        aria-label="Ouvrir la carte de visite"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="5" width="20" height="14" rx="2" />
          <line x1="2" y1="10" x2="22" y2="10" />
        </svg>
      </button>
    </header>
  );
}

export default Header;